export default __webpack_public_path__ + "static/media/Group 1385.84355448.svg";